import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiIconButton: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: designTokens.color.gray.hover.original.value,
                    },
                    '&:active': {
                        backgroundColor: designTokens.color.gray.active.original.value,
                    },
                    '&.Mui-disabled': {
                        color: designTokens.color.gray.limestone.value,
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&:active': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
                sizeSmall: {
                    fontSize: designTokens.typography.icon.small.size.value,
                    width: theme.spacing(3),
                    height: theme.spacing(3),
                },
                sizeMedium: {
                    fontSize: designTokens.typography.icon.medium.size.value,
                    width: theme.spacing(4),
                    height: theme.spacing(4),
                },
                sizeLarge: {
                    fontSize: designTokens.typography.icon.large.size.value,
                    width: theme.spacing(5),
                    height: theme.spacing(5),
                },
                colorPrimary: {
                    color: designTokens.color.gray.obsidian.value,
                },
                colorSecondary: {
                    color: designTokens.color.blue.default.value,
                    '&:hover': {
                        backgroundColor: designTokens.color.blue.default.alpha.hover.value,
                    },
                    '&:active': {
                        backgroundColor: designTokens.color.blue.default.alpha.active.value,
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=iconButtonTheme.js.map